import LegalPage from "../components/LegalPage";

/** /dmca — the copyright takedown policy (17 U.S.C. § 512). */
const DmcaPage = () => (
  <LegalPage title="DMCA Policy" updated="September 14, 2026">
    <p>
      Splatboard LLC ("Splatboard," "we") respects copyright and responds to
      notices of alleged infringement that comply with the Digital Millennium
      Copyright Act (17 U.S.C. § 512). This page explains how to send us a
      takedown notice for material on StreamLover — the streamlover.app website
      and the StreamLover mobile apps — and what happens after we receive one.
    </p>
    <p>
      Note that most live streams available through StreamLover are operated by
      independent broadcasters on their own infrastructure. Where the material
      you're concerned about originates with a broadcaster rather than with us,
      the fastest path is often to contact that broadcaster directly — but
      you're welcome to notify us as well, and we'll act on valid notices for
      material we host or link to.
    </p>

    <h2>Filing a takedown notice</h2>
    <p>
      To report material you believe infringes your copyright, send a written
      notice to our designated agent (below) that includes:
    </p>
    <ol>
      <li>
        identification of the copyrighted work you claim has been infringed (or
        a representative list, if the notice covers multiple works);
      </li>
      <li>
        identification of the material claimed to be infringing, with enough
        information for us to locate it — a URL is best;
      </li>
      <li>
        your contact information: name, mailing address, telephone number, and
        email address;
      </li>
      <li>
        a statement that you have a good-faith belief that use of the material
        in the manner complained of is not authorized by the copyright owner,
        its agent, or the law;
      </li>
      <li>
        a statement, made under penalty of perjury, that the information in the
        notice is accurate and that you are the copyright owner or authorized to
        act on the owner's behalf;
      </li>
      <li>your physical or electronic signature.</li>
    </ol>

    <h2>Designated agent</h2>
    <p>
      DMCA Agent
      <br />
      Splatboard LLC
      <br />
      <a href="mailto:dmca@streamlover.app">dmca@streamlover.app</a>
    </p>

    <h2>What happens next</h2>
    <p>
      When we receive a valid notice, we will remove or disable access to the
      identified material promptly and make a reasonable effort to notify the
      user who posted it, including a copy of the notice. That user may respond
      with a counter-notice.
    </p>

    <h2>Counter-notices</h2>
    <p>
      If material you posted was removed and you believe the removal was a
      mistake or misidentification, you may send our designated agent a written
      counter-notice that includes:
    </p>
    <ol>
      <li>
        identification of the material that was removed and the location where
        it appeared before removal;
      </li>
      <li>
        a statement, under penalty of perjury, that you have a good-faith belief
        the material was removed as a result of mistake or misidentification;
      </li>
      <li>
        your name, address, and telephone number, and a statement that you
        consent to the jurisdiction of the federal district court for your
        district (or, if outside the United States, the District of Delaware),
        and that you will accept service of process from the person who filed
        the original notice or their agent;
      </li>
      <li>your physical or electronic signature.</li>
    </ol>
    <p>
      If we receive a valid counter-notice, we'll forward it to the original
      complainant. Unless they notify us within 10 business days that they've
      filed a court action seeking to restrain the alleged infringement, we may
      restore the removed material within 10 to 14 business days.
    </p>

    <h2>Repeat infringers</h2>
    <p>
      In appropriate circumstances, we will terminate the accounts of users who
      are repeat infringers.
    </p>

    <h2>Misrepresentation</h2>
    <p>
      Under 17 U.S.C. § 512(f), anyone who knowingly and materially
      misrepresents that material is infringing, or that it was removed by
      mistake, may be liable for damages, including costs and attorneys' fees.
      Please make sure your notice or counter-notice is accurate before sending
      it.
    </p>

    <p className="legal__credit">
      Adapted from Automattic's{" "}
      <a href="https://github.com/Automattic/legalmattic">
        open-source legal documents
      </a>
      , available under a{" "}
      <a href="https://creativecommons.org/licenses/by-sa/4.0/">
        Creative Commons Attribution-ShareAlike 4.0
      </a>{" "}
      license. This document is likewise licensed under CC BY-SA 4.0.
    </p>
  </LegalPage>
);

export default DmcaPage;
